import { LEASE_OPTIONS, useChecklistsQuestionsQuery } from "modules/LeadsDashboard/hooks";
import { QUESTION_STATUSES_DEFAULT_STATUSES, useLeadsSnoozedFilters } from "modules/LeadsDashboard/Leads/SnoozedLeads/hooks";

import type { DropdownItemProps } from "components/Dropdown";
import type { SNOOZE_STATUSES, SNOOZE_TYPES } from "models";
import type { PossibleQuestionStatusOptions } from "modules/LeadsDashboard/hooks";

type UseSelectedTableFiltersProps = {
  snoozeStatusOptions: DropdownItemProps<string | SNOOZE_STATUSES>[];
  snoozeTypeOptions: DropdownItemProps<string | SNOOZE_TYPES>[];
  customerOkUserOptions: DropdownItemProps<string | number>[];
};

const getSelectedQuestionStatuses = (statuses: PossibleQuestionStatusOptions[] | null) => {
  if (statuses?.length === QUESTION_STATUSES_DEFAULT_STATUSES.length) return ["all"];
  return statuses?.map(String) ?? ["all"];
};

export const useSelectedTableFilters = ({ snoozeTypeOptions, snoozeStatusOptions, customerOkUserOptions }: UseSelectedTableFiltersProps) => {
  const {
    appointment_date_from,
    appointment_date_to,
    snooze_date_from,
    snooze_date_to,
    updated_on_from,
    updated_on_to,
    is_lease_company,
    snooze_status_id,
    last_customer_ok_is_me,
    questions,
    dealer_ids,
    location_ids,
    snooze_type_id,
    statuses
  } = useLeadsSnoozedFilters();

  const areAllDateFiltersReset = [appointment_date_from, appointment_date_to, snooze_date_from, snooze_date_to, updated_on_from, updated_on_to].every(x => !x);
  const selectedLeaseCompanyOption = is_lease_company === null ? LEASE_OPTIONS.All : is_lease_company ? LEASE_OPTIONS.Lease : LEASE_OPTIONS.NoLease;
  const selectedSnoozeStatusOption = snoozeStatusOptions.find(option => option.value === snooze_status_id)?.value.toString() || "all";
  const selectedCustomerOkUserOption = customerOkUserOptions.find(option => last_customer_ok_is_me && typeof option.value !== "string")?.value.toString() || "all";
  const { data: interventionQuestionOptions = [] } = useChecklistsQuestionsQuery({ dealer_ids, location_ids });
  const selectedTaskOption = snoozeTypeOptions.find(option => option.value === snooze_type_id)?.value.toString() || "all";
  const selectedQuestionStatuses = getSelectedQuestionStatuses(statuses);

  const selectedQuestions = questions
    ? questions.reduce((acc, questionId) => {
        const question = interventionQuestionOptions.find(element => element.filterValue === questionId);
        if (question) acc.push(question.key.toString());

        return acc;
      }, [] as string[])
    : ["all"];

  return {
    selectedQuestions,
    areAllDateFiltersReset,
    selectedLeaseCompanyOption,
    selectedSnoozeStatusOption,
    selectedCustomerOkUserOption,
    interventionQuestionOptions,
    selectedTaskOption,
    selectedQuestionStatuses
  };
};
